export enum DeviceStatus {
    UNKNOWN = 'UNKNOWN',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
    OK = 'OK'
}
